export const text = {
  OnboardingTask: "Onboardingtaak",
  OnboardingQuiz: "Onboardingquiz",
  OnboardingTemplate: "Onboardingtemplate",
  AddOnboardingTask: "Onboardingtaak toevoegen",
  AddOnboardingQuiz: "Onboardingquiz toevoegen",
  AddOnboardingTemplate: "Onboardingtemplate toevoegen",
  TaskType: "Taaktype",
  Attachment: "Bijlage",
  SubTitle: "Subtitel",
  TotalDays: "Totaal aantal dagen",
  Onboardingquizaddedsuccessfully: "Onboardingquiz succesvol toegevoegd",
  Onboardingquizupdatedsuccessfully: "Onboardingquiz succesvol bijgewerkt",
  OnboardingquizDeletedsuccessfully: "Onboardingquiz succesvol verwijderd",
  Onboardingtaskaddedsuccessfully: "Onboardingtaak succesvol toegevoegd",
  Anattachmentisrequired: "Een bijlage is verplicht",
  OnboardingTaskDeletedsuccessfully: "Onboardingtaak succesvol verwijderd",
  Onboardingtaskupdatedsuccessfully: "Onboardingtaak succesvol bijgewerkt",
  OnboardingtemplateDeletedsuccessfully:
    "Onboardingstemplate succesvol verwijderd",
  Onboardingtemplateupdatedsuccessfully:
    "Onboardingstemplate succesvol bijgewerkt",
  Onboardingtemplatecancelledsuccessfully:
    "Onboardingstemplate succesvol geannuleerd",
  Onboardingtemplatesubmittedsuccessfully:
    "Onboardingstemplate succesvol ingediend",
  Onboardingtemplateaddedsuccessfully:
    "Onboardingstemplate succesvol toegevoegd",
  PleaseaddtasktoyourOnboardingTemplate:
    "Voeg een taak toe aan het onboardingstemplate",
  formatsareallowed: "Formaten zijn toegestaan",
  Only: "Alleen",
  Onboarding: "Onboarding",
  PleaseaddQuestiontoyourQuiz: "Voeg een vraag toe aan de quiz",
};
